export const text = [
    `Autant dire qu’une reconversion est un parcours exigeant.`,
    `  Ce parcours peut être vécu de deux manières. Soit comme un parcours long et
    difficile, la personne ayant du mal à accepter son statut « d’étudiant(e) » et les
    prérogatives qui lui incombent. Soit comme une aventure excitante, permettant
    d’intégrer de nouvelles connaissances, de faire de nouvelles rencontres, un parcours
    rafraîchissant !`,
    ` Mieux vaut être dans un état d’esprit hyper-positif avec une grande motivation pour
    aborder ce chemin.`
]